import React from "react";
import { Container, ContainerBarSearch, ContainerCertificate, ContainerCertificateBarSearch, SectionCertificatePageLeft, SectionCertificatePageTitle, SectionPageLeft, SectionPageTitle } from "../styles";
import { PageTitle } from "../../components/PageTitle";
import PeopleIcon from "@mui/icons-material/People";
import { useTranslation } from "react-i18next";
import { SearchValidateCertificate } from "../../components/atoms/searchBars/SearchValidateCertificate";
import { BackdropLoading } from "../../components/BackdropLoading";
import { CompanyWorkerApi } from "../../services/CompanyWorkerApi";
import { ShowDialog } from "../../components/ShowDialog";
import { toast } from "react-toastify";
import { LoadingProgress } from "../../components/LoadingProgress";

export const ValidateCertificate = () => {
    const { t } = useTranslation();
    const [filteredRequest, setFilteredRequest] = React.useState([]);
    const searchText = React.useRef("");
    //const [searchText, setSearchText] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [loadingData, setLoadingData] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [showDialog, setShowDialog] = React.useState(false);
    const companyWorkerApi = new CompanyWorkerApi();
    const [dialog, setDialog] = React.useState({
        title: '',
        message: '',
        status: false
    });

    const loadData = async () => {

        setLoadingData(true)
        let response = await companyWorkerApi.getCertificateByUniqueCode(searchText.current);

        if (response.status === 200) {

            const type = response.headers['content-type'];
            const blob = new Blob([response.data], { type });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
            setLoadingData(false)
        }else if(searchText.current === '' || !searchText.current){
            toast.error(() => (
                <div>
                    {t("certificateValidate.messages.validationStarted.nocontent")}
                    <br />
                    {response.errors}
                </div>
            ));
        }
         else {
            toast.error(() => (
                <div>
                    {t("certificateValidate.messages.validationStarted.error")}
                    <br />
                    {response.errors}
                </div>
            ));
        }

        setLoadingData(false)
    }

    const handleChange = (id) => {
        loadData(id)
    }

    return (
        <>
            <Container>
                <BackdropLoading open={loading} />
                <ShowDialog openDialog={showDialog} dialog={dialog} />
                <SectionCertificatePageTitle>
                    <SectionPageLeft>
                        <PageTitle title={t("system.certificateValidate.title")} icon={<PeopleIcon />} />
                        <ContainerCertificateBarSearch>
                            <SearchValidateCertificate isLoading={loadingData} rows={data} setFilteredRequest={setFilteredRequest} searchText={searchText} handleChange={handleChange} />
                        </ContainerCertificateBarSearch>

                    </SectionPageLeft>
                    {loadingData &&
                        <LoadingProgress />
                    }

                </SectionCertificatePageTitle>

            </Container>

        </>
    )
}